// src/components/Navbar/Navbar.js
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { AuthContext } from '../../context/AuthContext';
import { ThemeContext } from '../../context/ThemeContext';
import ThemeToggle from '../ThemeToggle/ThemeToggle';
import { IoMdLogOut } from "react-icons/io";
import { UserAvatar } from '../../UIComponents/UserAvatar.ts';
import TooltipButton from '../Tools/TooltipButton.tsx';
import Breadcrumbs from '../../UIComponents/Breadcrumbs.tsx';
import JoyrideTest from '../../UIComponents/JoyrideTour/JoyrideTest.tsx';
import { FaLightbulb } from 'react-icons/fa';
import { useJoyride } from '../../UIComponents/JoyrideTour/JoyrideContext.tsx';

const NavbarContainer = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.50rem 1rem;
  background-color: ${({ theme }) => theme.colors.card};
  box-shadow: ${({ theme }) => theme.shadows.small};
  position: sticky;
  top: 0;
  z-index: 100;
`;

const LogoutIcon = styled(IoMdLogOut)`
  transition: transform 0.2s ease, color 0.2s ease;
  cursor: pointer;

  &:hover {
    transform: rotate(-15deg) scale(1.1);
    color: ${({ theme }) => theme.colors.danger || 'red'};
  }
`;


const PageTitle = styled.h1`
  font-size: 1.25rem; // Reduced from 1.5rem
  margin: 0;
  color: ${({ theme }) => theme.colors.text};
`;

const NavItems = styled.div`
  display: flex;
  align-items: center;
   gap: 1rem; // Reduced from 1.5rem
`;

const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;


const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const { themeConfig } = useContext(ThemeContext);
 const { startJoyRide, setStartJoyRide } = useJoyride();

  return (
    <NavbarContainer>
      <PageTitle> <Breadcrumbs />
         <JoyrideTest />
      </PageTitle>
      <NavItems>
        {/* <TooltipButton title={!startJoyRide ? "Need Help? Start Guided Tour" : "Hide Tips"}>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <button className='p-0 '
            onClick={() => setStartJoyRide(true)}
              style={{
                color: !startJoyRide ? themeConfig.colors.blankandwhite : themeConfig.colors.primary,
                transition: 'color 0.3s',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '1.5rem',
                lineHeight: "0px"
              }}
            >
              <FaLightbulb className='guide-icon' />
            </button>
            {startJoyRide && (
              <span
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  width: '8px',
                  height: '8px',
                  backgroundColor: themeConfig.colors.primary,
                  borderRadius: '50%',
                }}
              />
            )}
          </div>
        </TooltipButton> */}
        <ThemeToggle />
        {user && (
          <UserSection>
            {/* <UserAvatar>
              {user.name.charAt(0)}
            </UserAvatar> */}
            <TooltipButton title="Logout">
              <LogoutIcon className='j_h_lgout' size={30} onClick={() => { logout() }} />
            </TooltipButton>
          </UserSection>
        )}
      </NavItems>
    </NavbarContainer>
  );
};

export default Navbar;